@import (reference) "../../references.less";

.root {
}

.mainButton {
  margin: auto;
}

.input {
  visibility: hidden;
}
